module.exports = __webpack_public_path__ + "assets/media/dan-2.69519cff.png";